// ** Redux Imports
import React from 'react'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import urls from  '@src/@core/auth/jwt/urls'
import { toast } from 'react-toastify'
// ** Axios Imports
import axios from 'axios'
// import { errorToast, sucessToast } from '../../../components/messageToast/messageToast'
// const qs = require('qs')
export const getAllData = createAsyncThunk('appDocuments/getAllData', async (params) => {
  const instanceGet = axios.create({
    baseURL: urls.url,
    timeout: 15000,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
  })
  const response = await instanceGet.get(`/customers/documents/`, {params: {p:params.page, idCustomer:params.idCustomer, id:params.document, status:params.status, start:params.start, end:params.end}})
  return response
})

export const getDocumentsContifico = createAsyncThunk('appDocuments/getDocumentsContifico', async(props, {dispatch, getState}) => {
  const state = getState()
  const instancePost = axios.create({
    baseURL: urls.url,
    timeout: 15000,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
  })

  const promise = async () => {
    try {
      const resp = await instancePost.post("/customers/documents/sync_documents_with_contifico/", {})
      console.log(resp)
      dispatch(getAllData({ page: 1, idCustomer: "", document: "", status: "", start: "", end: "" }))
    } catch (err) {
      console.error(err)
    }
  }
  // instancePost.request({
  //   method: "post", 
  //   url: "/customers/documents/sync_documents_with_contifico/", 
  //   data: {},
  //   onUploadProgress: p => {
  //     const progress = p.loaded / p.total

  //     // check if we already displayed a toast
  //     if (props.toastId.current === null) {
  //       props.toastId.current = toast('Upload in Progress', { progress })
  //     } else {
  //       toast.update(props.toastId.current, { progress })
  //     }
  //   }
  // }).then(data => {
  
  //   toast.done(props.toastId.current)
  //   console.log(data)
  //   dispatch(getAllData({ page: 1, idCustomer: "", document: "", status: "", start: "", end: "" }))
  // })
  if (!state.loading) {
    await toast.promise(promise, {
      pending: 'Sincronizando documentos',
      loading: 'Sincronizando documentos',
      success: 'Documentos sincronizados',
      error: 'Ha ocurrido un error'
    })
  }
  
})

export const cleanDocuments = createAsyncThunk('appDocuments/cleanContacts', () => {
  return "clean"
})

export const appDocumentsSlice = createSlice({
  name: 'appDocuments',
  initialState: {
    allData: [],
    total: 1,
    loading: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.fulfilled, (state, action) => {
        console.log(action)
        state.allData = action.payload.data.results
        state.total = action.payload.data.count
      })

      .addCase(getDocumentsContifico.pending, (state) => {
        state.loading = true
        console.log("Pending ....")
      })

      .addCase(getDocumentsContifico.fulfilled, (state, action) => {
        console.log(action)
        state.loading = false
        console.log("Completo")
      })
  
      .addCase(cleanDocuments.fulfilled, (state) => {
        state.allData = []
        state.total = 1
      })

  }
})

export default appDocumentsSlice.reducer
